export default {
  topicDetail_just_look_essence: 'Highlights Only',
  topicDetail_follow_circle: 'Follow',
  topicDetail_follow_num: '{transformNum, plural, =0 {no follows.} =1 {one follow.} other {# follows.}}',
  topicDetail_no_circle_intro: 'No circle introduction',
  topicDetail_latest_publish: 'Post as the latest',
  topicDetail_found: 'You can find the content in "My posts - I managed posts" after removing it, and it can be restored to shelves. Remove?'
}
